<template>
    <div>
        <template v-if="recon_transaction === true">
            <div class="page-top mb-1 mb-3 clearfix">
            <h1 class='pl-4 mb-2'> Pending Batch ID : {{batch_id}} </h1><br>
            <div class='px-4 d-flex justify-content-between'>
             <div>
             <h4>Total Number of Transactions: {{totalTransactions}}</h4><br>
            <h4>Number of successful Transactions: {{successfulTransactions}}</h4><br>
           </div>
         <div>
         <h4>Number of Failed Transactions: {{failedTransactions}}</h4><br>
         <h4>Number of Pending Transactions: {{pendingTransactions}}</h4>
       </div>
     </div>     
              <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" companyName="" />
              </div>
            </div>
            <table id="ReconBatchListing" class="table" width="100%">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Account #</th>
                        <th>Account Type</th>
                        <th>Amount</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="recon_transaction === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="recon_transaction === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
              recon_transaction: null,
              batch_id: this.$route.params.id,
              totalTransactions: 0,
              successfulTransactions: 0,
              failedTransactions: 0,
              pendingTransactions: 0,
            };
        },
        methods: {
            callDataTable(){
                var that = this;
                var ReconBatchListing = $('#ReconBatchListing').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                      type: "GET",
                        "url": "/api/reconBatchListing/"+this.$route.params.id,
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id'},
                        {data: 'name'},
                        {data: 'account_number'},
                        {data: 'account_type'},
                        {data: 'net_salary'},
                        {data: 'created_at'},
                        {data: 'updated_at'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/reconBatchList/'+full['id'];
                            //return '<a href="javascript:void(0);" onclick="hi(full[\'id\'])" class="btn btn-primary" >Recon</a>';
                            return '<a href="javascript:void(0);" onclick="window.markSuccesful('+full['id']+')"  class="btn btn-primary">Successful</a>&nbsp<a href="javascript:void(0);" onClick="window.markFailed('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="btn btn-primary"> Failed </a>';;
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    // "columnDefs": [{
                    //         className: "text-center",
                    //         "targets": [ 6 ]
                    //     }],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                        that.successfulTransactions = json.successfulTransactions;
                        that.failedTransactions = json.failedTransactions;
                        that.pendingTransactions = json.pendingTransactions;
                        that.totalTransactions = json.totalTransactions
                    }
                });

              $('#customSearch').on( 'keyup', function (e) {
                if (e.keyCode === 13) {
                  ReconBatchListing.search(this.value).draw();
                }
              });
            },
          markSuccesful(id){
            Swal.fire({
              title: 'Are you sure?',
              text: "Enter transaction id of successful transaction",
              type: 'warning',
              input: 'number',
              inputLabel: 'Your IP address',
              inputValue: '',
              showCancelButton: true,
              confirmButtonText: 'Yes, Sucessful',
              inputValidator: (value) => {
                if (!value) {
                  return 'Please enter Transaction Id!'
                }
              }
            }).then((result) => {
              if (result.value) {
                axios.get("/api/markReconTransactionSuccessful/"+id+"/"+result.value)
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','Transaction marked successfully!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          },
          markFailed(id){
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to mark this transaction failed?",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, Failed'
            }).then((result) => {
              if (result.value) {
                axios.get("/api/markReconTransactionFailed/"+id)
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','Transaction marked Failed!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          }
        },
        mounted() {
          var gThat = this;
            this.$Progress.start();
			this.can('recon_transaction').then(result => {
                this.recon_transaction = result.recon_transaction;
            }).then(result => {
                if(this.recon_transaction == true){
					this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
          window.markSuccesful = function(id) {
            gThat.markSuccesful(id);
          }

            window.markFailed = function(id) {
              gThat.markFailed(id);
            }
        },
    }
</script>
